module.exports = __webpack_public_path__ + "4610010f425c140b99c88b6819ce1c02.woff2";